import { handleAction } from 'redux-actions';

import { TOGGLE_SIDE_MENU } from './actions';

const toggleSideMenu = handleAction(
  [TOGGLE_SIDE_MENU],
  state => ({ isSideMenuOpen: state.isSideMenuOpen ? false : true }),
  { isSideMenuOpen: false }
);

export default toggleSideMenu;
